import { Button, Row, theme } from 'antd';
import React, { Component } from 'react';
import { ReactComponent as DiceIcon } from '../assets/dice.svg';
import { ReactComponent as PaperIcon } from '../assets/hand-paper.svg';
import { ReactComponent as RockIcon } from '../assets/hand-rock.svg';
import { ReactComponent as ScissorsIcon } from '../assets/hand-scissors.svg';
import { ChoiceTypeEnum, GameTypeEnum } from '../store/game.types';
import { ReactComponent as HeadsIcon } from '../assets/heads.svg';
import { ReactComponent as TailsIcon } from '../assets/tails.svg';
import { AppContext, AppContextValue } from '../../../theme/AppContextProvider';

const buttons = {
  [GameTypeEnum.KNB]: [
    { id: ChoiceTypeEnum.ROCK, icon: <RockIcon /> },
    { id: ChoiceTypeEnum.SCISSORS, icon: <ScissorsIcon /> },
    { id: ChoiceTypeEnum.PAPER, icon: <PaperIcon /> },
    { id: ChoiceTypeEnum.DICE, icon: <DiceIcon /> },
  ],
  [GameTypeEnum.HOT]: [
    { id: ChoiceTypeEnum.HEADS, icon: <HeadsIcon /> },
    { id: ChoiceTypeEnum.TAILS, icon: <TailsIcon /> },
    { id: ChoiceTypeEnum.DICE, icon: <DiceIcon /> },
  ],
};

interface IProps {
  style?: React.CSSProperties;
  onChange?: ((id?: ChoiceTypeEnum) => void) | undefined;
  value?: ChoiceTypeEnum | undefined;
  disabled?: boolean | undefined;
  type: GameTypeEnum;
  isOdd?: boolean;
}

class _ChoiceGroup extends Component<IProps> {
  static contextType = AppContext;
  render() {
    const { globalTheme } = this.context as AppContextValue;
    console.log(theme.getDesignToken());
    const { onChange, value, disabled, type, isOdd } = this.props;
    const height: number = (this.props.style?.height as number) || 36;
    let bg = this.props.style?.backgroundColor || globalTheme?.red2;
    let colorSelected = this.props.style?.color || globalTheme?.red5;

    if (isOdd !== undefined) {
      bg = isOdd ? globalTheme?.red2 : globalTheme?.blue2;
      colorSelected = isOdd ? globalTheme?.red5 : globalTheme?.blue6;
    }

    return (
      <Row style={{ borderRadius: 20, backgroundColor: bg, padding: 3, opacity: disabled ? 0.5 : 1 }}>
        {buttons[type].map(b => {
          const selected = value === b.id;
          return (
            <Button
              key={b.id}
              disabled={disabled}
              style={{
                height: height,
                width: 50,
                borderRadius: 20,
                backgroundColor: selected ? '#fff' : 'transparent',
                borderWidth: 0,
              }}
              icon={React.cloneElement(b.icon, {
                style: { height, width: height, fill: selected ? colorSelected : '#fff' },
              })}
              onClick={() => onChange?.(b.id)}
            />
          );
        })}
      </Row>
    );
  }
}

export const ChoiceGroup = _ChoiceGroup;
